var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHelp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  fillRule: "evenodd",
  d: "M24 4a20 20 0 1 0-.01 39.99A20 20 0 0 0 24 4",
  clipRule: "evenodd",
  "data-filled": "true"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  fillRule: "evenodd",
  d: "M24 4.02a20 20 0 1 0 0 40 20 20 0 0 0 0-40m0 37.4c-9.59 0-17.4-7.81-17.4-17.4S14.41 6.62 24 6.62s17.4 7.81 17.4 17.4-7.81 17.4-17.4 17.4",
  clipRule: "evenodd",
  "data-filled": "false"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-accent-fill, var(--thc-icon-accent-fill-default, white))",
  fillRule: "evenodd",
  d: "M24 36a2 2 0 1 0 0-4 2 2 0 0 0 0 4m1.56-23.82a7.31 7.31 0 0 0-8.83 7.12 1.3 1.3 0 1 0 2.6 0 4.66 4.66 0 0 1 5.7-4.57 4.68 4.68 0 0 1 .86 8.85 5.36 5.36 0 0 0-3.18 4.92 1.3 1.3 0 1 0 2.6 0c0-1.11.64-2.1 1.63-2.54a7.26 7.26 0 0 0-1.38-13.77z",
  clipRule: "evenodd"
})));
export { SvgHelp as ReactComponent };
export default new URL("/home/runner/work/motorway-seller-webapp/motorway-seller-webapp/node_modules/@motorway/mw-highway-code/src/assets/svgs/help.svg", import.meta.url).toString();